import * as bodymovin from 'bodymovin';

function BodymovinAnimation(data, element) {
    this.data = data;
    this.element = element;
    this.elementClass = element.attr('class');
    this.square = this.element.parents('.square-button');
    this.animation = null;
}

BodymovinAnimation.prototype.start = function() {
    var square = this.square;
    var element = this.element;

    this.animation = bodymovin.loadAnimation({
        container: this.element.get(0),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: this.data
    });

    this.animation.addEventListener('DOMLoaded', function(){
        element.attr('class', null);
        square.addClass('bodymovin-loaded');
    });
};

BodymovinAnimation.prototype.destroy = function() {
    if (this.animation) {
        this.animation.destroy();
        var square = this.square;
        var element = this.element;

        element.attr('class', this.elementClass);
        square.removeClass('bodymovin-loaded');
    }
};

/**
 * Detailed fallacy page animations
 **/
app.add({

    onFallacyDetailedUpdate: function(app, fallacy){
        var $target = $('.fallacy-detailed .square-button');
        this.loadAnimation(fallacy, $target);
    },

    onHomeMakeInactive: function(app, data) {
    },

    onHomeMakeActive: function(app, data) {
        this.loadAnimation(data.fallacy, data.item);
    },

    loadAnimation: function(fallacy, $target) {
        var resolveAnimationFile = function(fallacyName) {
            var map = {
                'anchoring': require('./data/1_anchoring.json'),
                'the-sunk-cost-fallacy': require('./data/2_sunk-cost.json'),
                'the-availability-heuristic': require('./data/3_availability-heuristic.json'),
                'the-curse-of-knowledge': require('./data/4_curse-of-knowledge.json'),
                'confirmation-bias': require('./data/5_confirmation-bias.json'),
                'the-dunning-kruger-effect': require('./data/6_dunning-kruger.json'),
                'belief-bias': require('./data/7_belief-bias.json'),
                'self-serving-bias': require('./data/8_self-serving.json'),
                'the-backfire-effect': require('./data/9_backfire.json'),
                'the-barnum-effect': require('./data/10_barnum-effect.json'),
                'groupthink': require('./data/11_group-think.json'),
                'negativity-bias': require('./data/12_negatvity-bias.json'),
                'declinism': require('./data/13_declinism.json'),
                'the-framing-effect': require('./data/14_framing-effect.json'),
                'fundamental-attribution-error': require('./data/15_fundamental-attribution-error.json'),
                'the-halo-effect': require('./data/16_halo-effect.json'),
                'optimism-bias': require('./data/17_optimism-bias.json'),
                'pessimism-bias': require('./data/18_pessimism-bias.json'),
                'just-world-hypothesis': require('./data/19_just-world-bias.json'),
                'in-group-bias': require('./data/20_in-group-bias.json'),
                'the-placebo-effect': require('./data/21_placebo-bias.json'),
                'the-bystander-effect': require('./data/22_bystander-effect.json'),
                'reactance': require('./data/23_reactance.json'),
                'the-spotlight-effect': require('./data/24_spotlight-effect.json')
            };
            return map[fallacyName];
        };

        var playAninmationFile = function(file, $square) {
            var $element = $square.find('i');

            if (app.bodymovinAnim) {
                app.bodymovinAnim.destroy();
            }

            app.bodymovinAnim = new BodymovinAnimation(file, $element);
            app.bodymovinAnim.start();
        };

        var animationFile = resolveAnimationFile(fallacy.name);
        playAninmationFile(animationFile, $target);
    }

});



// WEBPACK FOOTER //
// ./resources/assets/js/animations/icon-animations.js